module.exports = __webpack_public_path__ + "img/success.38d89be2.png";